import { createContext, useContext, useRef } from "react";

const MapRefContext = createContext(null);

export const MapRefProvider = ({ children, value }) => {
  const contextValue = value || useRef(null);
  return (
    <MapRefContext.Provider value={contextValue}>
      {children}
    </MapRefContext.Provider>
  );
};

export const useMapRef = () => useContext(MapRefContext); 